import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {CHANGE_PLAN_MODAL_V2_HEIGHT_PX} from '@Panels/change-plan-modal-v2/change-plan-modal-v2.types';

/**
 * Opens the dialog for the manageapp design-system preview: stand-in subscription data, and a Confirm
 * button that closes instead of charging. Bypasses openChangePlanModal because the preview must reach
 * the redesigned dialog regardless of the feature flag, and must never land on the classic one.
 */
export const openChangePlanModalV2Preview = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.CHANGE_PLAN_MODAL_V2,
      panelProps: {isPreview: true},
    })
  );
};

/** The plan step keeps the design height and only grows when its content would otherwise scroll. */
export const getPlanStepBoxHeight = (contentHeight: number): number => {
  return Math.max(Math.ceil(contentHeight), CHANGE_PLAN_MODAL_V2_HEIGHT_PX);
};
